import React from 'react'
import { Icon as ChIcon, Square } from '@chakra-ui/react'
import RemoteIcon from '../RemoteIcon'
import icons from './Icons'

const Icon = ({ children, icon, ...props }) => {
  const i = icon ?? children
  if (!i) return null
  if (i.startsWith('http')) return <RemoteIcon width="1.5em" src={i} {...props} />
  return <ChIcon width="1.5em" height="1.5em" as={icons[i]} {...props} />
}

export default Icon
